import React, { memo } from "react";

import { Row ,Col,Card,Button} from 'react-bootstrap';
import { NavLink } from "react-router-dom";

const SaveAndExitScreen = memo( function SaveAndExitScreen({ mockTitle }) {

	return (
		<div className="content questionsArea deviceTestPage mock-container">
			<Row>
				<Col xs={12}>
					<Card className="mock-header-gap shadow-none border-0">
						<Card.Body className="mock-resource-text">
							
							<Row className="testFinish unselectable justify-content-center text-center">
								<Col xs={12} sm={10} md={8} lg={6} xl={5}>
									
									<h4 className="mt-0">Test Pending</h4>

									<p className="mb-3">
									This test is not complete. You can resume this test from{" "}
									<strong>Pending Test area</strong>.
									</p>

									<NavLink to="/admin/pending" className="text-decoration-none">
									<button className="btn btn-primary px-4">
										Continue
									</button>
									</NavLink>

								</Col>
							</Row>

						</Card.Body>
					</Card>
				</Col>
			</Row>
		</div>
	);
});

export default SaveAndExitScreen;